import { gql } from '@edreamsodigeo/frontend-api-client';

import { universalPriceBreakdownFragment } from './priceBreakdown.fragments';

const contactDetailsFragment = gql`
  fragment UniversalContactDetailsFields on UniversalShoppingBasketContactDetails {
    address
    cityName
    country
    countryCode
    countryPhoneNumber
    email
    lastName
    name
    phoneNumber
    postcode
    typePhoneNumber
  }
`;

export const shoppingBasketResponseFragment = gql`
  fragment UniversalShoppingBasketResponseFields on UniversalShoppingBasketResponse {
    checkoutStatus
    contactDetails {
      ...UniversalContactDetailsFields
    }
    priceBreakdown {
      ...UniversalPriceBreakdownFields
    }
    products {
      id
      type
    }
    bundles {
      id
      type
      checkoutFlow
    }
    promoCodes {
      amount {
        amount
        currency
      }
      code
      id
    }
    shoppingBasketId
    shoppingBasketToken {
      token
    }
    userId
  }
  ${universalPriceBreakdownFragment}
  ${contactDetailsFragment}
`;
